// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Lh2Sq","label":"Completed_label__1W7Nj"};